export const NoCalls = () => {
  return (
    <section
      className="relative py-28 md:py-40 bg-[#F7E9EC] border-y border-[#EDD9DE]"
      data-testid="no-calls-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-light leading-[1.05] tracking-tight text-[#3B2630]">
          No calls.
          <span className="italic text-[#C9587E]"> No calendar.</span>
          <span className="block mt-2">No masking.</span>
        </h2>

        <div className="warm-divider-h my-12 max-w-md mx-auto" />

        <div className="font-body text-base md:text-lg text-[#6B5058] leading-relaxed space-y-5 max-w-2xl mx-auto text-left md:text-center">
          <p>
            Just press record from your car, your closet, mid-walk or
            chillin&rsquo; in your bed and I&rsquo;ll respond within 24 hours.
          </p>
          <p className="font-serif italic text-2xl md:text-3xl text-[#3B2630] !mt-10 leading-snug">
            This is the only coaching container that works{" "}
            <span className="text-[#C9587E]">WITH</span> your nervous system
            instead of asking you to override it.
          </p>
        </div>

        <div className="mt-12 space-y-3 font-body text-base md:text-lg text-[#6B5058]">
          <p>No calls to prepare for.</p>
          <p>No Zoom face to put on.</p>
          <p>
            No scheduling something three weeks out when you need someone
            right now.
          </p>
        </div>

        <p className="font-serif italic text-2xl md:text-4xl text-[#C9587E] mt-14 leading-snug">
          Just your voice in my ear and mine in yours.
        </p>
      </div>
    </section>
  );
};
